<template>
    <div class="bgc-f">
        <div class="login">
            <div class="login-form">
                <div class="login-logo"><router-link to="/"><img src="../assets/images/logo-login.jpg" alt=""></router-link></div>
                <div class="login-form-item">
                    <div class="login-form-lab">手机号码：</div>
                    <div class="login-form-val"><input class="inp" type="number" v-model="tel"></div>
                </div>
                <div class="login-form-item">
                    <div class="login-form-lab">验证码：</div>
                    <div class="login-form-val"><input class="inp" type="number" v-model="code"><input class="code" type="button" value="获取验证码" @click="getCode" ref="code"></div>
                </div>
                <div class="login-form-bar">
<!--                    <router-link class="left" to="">注册新账户</router-link>-->
                    <router-link class="right" to="">忘记密码</router-link>
                </div>
                <input type="submit" class="login-form-btn" value="登　录" @click="login">
                <div class="oauth" v-if="isshowlogin">
                    <div class="oauth-hint"><span>合作账号登录</span></div>
                    <div class="oauth-box">
                        <div class="item" @click="weChatLogin"><img src="../assets/images/icon-weixin.png" alt=""></div>
                        <div class="item"><img src="../assets/images/icon-qq.png" alt=""></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="copyright">京ICP备16020840号</div>

        <van-popup v-model="showTel" :overlay="true">
            <div class="login-form s2">
                <div class="login-form-lab s2">绑定手机号</div>
                <div class="login-form-item">
                    <div class="login-form-lab">手机号码：</div>
                    <div class="login-form-val"><input class="inp" type="number" v-model="tel2"></div>
                </div>
                <div class="login-form-item">
                    <div class="login-form-lab">验证码：</div>
                    <div class="login-form-val">
                        <input class="inp" type="number" v-model="code2">
                        <input class="code" type="button" value="获取验证码" @click="getCode" ref="code">
                    </div>
                </div>
                <div class="formw01-item-ft">
                    <div class="btn s1" @click="showTel = false">取　消</div>
                    <div class="btn s2" @click="saveTel">保　存</div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>

    import { Toast, Popup } from 'vant';

    export default {
        name: "Login",
        data: function(){
            return {
				isshowlogin:false,
                showTel: false,
                tel: '',
                code: '',
                tel2: '',
                code2: '',
                loginCode: '',
                loginState: ''
            }
        },
        components: {
            [Toast.name]: Toast,
            [Popup.name]: Popup
        },
        mounted(){
			
            const _this = this;
            if (_this.$route.query.code != '' && _this.$route.query.code != null) {
                _this.loginCode = _this.$route.query.code;
                _this.loginState = _this.$route.query.state;
                let params = new FormData();
                params.append('code', _this.loginCode);
                params.append('state', _this.loginState);
                const toast1 = Toast.loading({
                    mask: true,
                    message: '登录中...'
                });
                _this.api.wxLogin(params).then(function(response){
                    toast1.clear();
                    if (response.status == 11) {
                        _this.showTel = true;
                    } else if (response.status == 2) {
                        Toast(response.msg)
                    } else if (response.status == 1) {
                        Toast(response.msg)
                        _this.$router.push('/')
                    }
                })
            }
			this.isshowlogin=!swan.webView.getEnv().smartprogram
			
        },
        methods: {
            getCode () {
                const _this = this;
                let telreg=/^[1][3,4,5,7,8][0-9]{9}$/;
                if (_this.tel === '') {
                    Toast('手机号不能为空')
                } else if (!telreg.test(_this.tel)) {
                    Toast('手机号格式不正确')
                } else {
                    let params = new FormData();
                    params.append('mobile', _this.tel);
                    _this.api.sendMsg(params).then(function (response) {
                        Toast(response.msg);
                        if (response.status === 1) {
                            _this.countTime(_this.$refs.code);
                        }
                    })
                }
            },
            login () {
                const _this = this;
                let telreg=/^[1][3,4,5,7,8][0-9]{9}$/;
                if (_this.tel === '') {
                    Toast('手机号不能为空')
                } else if (!telreg.test(_this.tel)) {
                    Toast('手机号格式不正确')
                } else {
                    if (_this.code == '') {
                        Toast('验证码不能为空')
                    } else {
                        let params = new FormData();
                        params.append('login_type', 'verify_login');
                        params.append('mobile', _this.tel);
                        params.append('verify_code', _this.code);
                        _this.api.login(params).then(function(response){
                            Toast(response.msg);
                            if (response.status === 1) {
                                _this.$router.push('/');
                            }
                        })
                    }
                }
            },
            countTime (el) {
                var count = 60;
                (function fun () {
                    if (count === 0) {
                        count = 60;
                        el.value = '获取验证码';
                        el.disabled = false;
                        return
                    } else {
                        count--;
                        el.value = count + 's';
                        el.disabled = true;
                    }
                    setTimeout(function(){fun()},1000)
                })()
            },
            weChatLogin(){
                const _this = this;
                _this.api.getLoginUrl().then(function(response){
                    const url = response.url;
                    location.href = url;
                })
            },
            saveTel () {
                const _this = this;
                let params = new FormData();
                params.append('mobile', _this.tel);
                params.append('captcha', _this.code);
                _this.api.saveMobile(params).then(function(response){
                    Toast(response.msg);
                    if (response.status == 1) {
                        _this.showTel = false;
                        Toast('绑定手机号成功');
                        _this.$router.push('/');
                    }
                })
            },
        }
    }
</script>

<style scoped>
    .copyright {text-align: center;font-size: .18rem;color: #898989;margin-top: .2rem;}
    .login-form.s2 {
        margin: 0;padding: .3rem;width: 80vw;
    }
    .login-form-lab.s2 {font-size: .4rem;font-weight: bold;text-align: center;}
</style>
